import Logo from '#/assets/images/logo.png';
import { FieldError } from '#/common/components';
import { Button, Input } from '#/components/ui';
import { useForgetPassword } from '..';

const ForgotPassword = () => {
    const {
        navigateToLogin,
        handleChangeForgot,
        handleSubmitForgot,
        forgotErrors,
        forgotTouched,
        forgotValues,
        forgotApiLoading,
        hasEmailSent,
    } = useForgetPassword();

    return (
        <div className='min-h-screen bg-grid-lines bg-cover bg-center bg-no-repeat flex items-center justify-center px-4'>
            <div className='w-full min-h-[calc(100dvh-67px)] sm:min-h-0 flex flex-col gap-12 justify-center items-center max-w-md bg-white rounded-2xl shadow-md px-12 py-16'>
                <img src={Logo} alt='logo' className='w-20 h-20' />
                <div className='flex flex-col gap-6'>
                    <div className='text-center space-y-3'>
                        <h3 className='text-secondary font-cormorant text-[2rem] font-bold'>
                            {hasEmailSent ? 'Check Your Email' : 'Forgot Your Password'}
                        </h3>
                        <p className='text-sm font-normal leading-4 text-gray500'>
                            {hasEmailSent ? (
                                <>
                                    Please check the email address <strong>{forgotValues?.email}</strong> for
                                    instructions to reset your password!
                                </>
                            ) : (
                                'Enter your email address and we will send you instructions to reset your password.'
                            )}
                        </p>
                    </div>

                    <form onSubmit={handleSubmitForgot} className='space-y-4 w-full'>
                        {!hasEmailSent && (
                            <div className='space-y-2 min-w-[18.5rem] sm:w-[22rem] xl:w-[24.3125rem]'>
                                <label htmlFor='email' className='block text-sm font-medium text-gray700'>
                                    Email
                                </label>
                                <Input
                                    id='email'
                                    type='email'
                                    placeholder='Enter your email'
                                    value={forgotValues?.email}
                                    onChange={handleChangeForgot}
                                    className='w-full h-[2.625rem] px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder:text-sm'
                                />

                                <FieldError error={forgotTouched?.email && forgotErrors?.email} />
                            </div>
                        )}

                        <Button
                            type='submit'
                            disabled={forgotApiLoading}
                            className='min-w-[18.5rem] sm:w-[22rem] xl:w-[24.3125rem] h-[2.625rem] flex justify-center py-3 px-5 border border-transparent text-sm font-medium rounded-lg cursor-pointer'
                        >
                            {hasEmailSent ? 'Resend Email' : 'Reset Password'}
                        </Button>
                    </form>

                    <div className='text-center '>
                        <Button
                            type='button'
                            variant='link'
                            onClick={navigateToLogin}
                            className='text-sm text-gray500 hover:underline cursor-pointer'
                        >
                            Back to Login
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { ForgotPassword };
